import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {debounceTime, distinctUntilChanged, Observable, Subject, switchMap} from "rxjs";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ClaimDto} from "../../../../auto-generated-server-dtos/adjuster/claim/claim-dto";
import {ValidationFailedModalComponent} from "../validation-failed-modal/validation-failed-modal.component";
import {UpdateAuthorizationNumberService} from "./services/update-authorization-number.service";
import {ClaimFormValidationService} from "../../../../claim/services/claim-form-validation.service";
import {PushToE2Service} from "./services/push-to-e2.service";
import Utils from "../../../../helpers/utils";
import {take} from "rxjs/operators";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-claim-authorization-number',
  templateUrl: './claim-authorization-number.component.html',
  styleUrls: ['./claim-authorization-number.component.scss']
})
export class ClaimAuthorizationNumberComponent implements OnInit {
  @Input() claimDto!: ClaimDto | null;
  @Input() minimalUi: boolean = false;
  @Output() pushedToE2 = new EventEmitter<void>();
  protected readonly Utils = Utils;
  private claimAuthorizationNumber$ = new Subject<string | null>();
  isSubmitting = false;

  constructor(
    private updateAuthorizationNumberService: UpdateAuthorizationNumberService,
    private claimFormValidationService: ClaimFormValidationService,
    private pushToE2Service: PushToE2Service,
    private ngbModal: NgbModal,
  ) {
  }

  ngOnInit(): void {
    this.claimAuthorizationNumber$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((authorizationNumber) =>
        this.updateAuthorizationNumberService.updateClaimAuthorizationNumber(this.claimDto!.claimId, authorizationNumber)
      )
    ).subscribe();
  }

  updateClaimAuthorizationNumber() {
    this.claimAuthorizationNumber$.next(this.claimDto!.authorizationNumber!);
  }

  isValidAuthorizationNumber(): boolean {
    return Utils.isValidAuthorizationNumber(this.claimDto!.authorizationNumber);
  }

  viewClaimInE2(): void {
    if (this.isValidAuthorizationNumber()) {
      const authorizationNumber = this.claimDto!.authorizationNumber as string;
      const matchResult = authorizationNumber.match(/\d{6,}/);
      const numberSuffix = matchResult ? matchResult[0] : '';
      if (numberSuffix) {
        const url = `${environment.e2Url}/claims/${numberSuffix}/detail`;
        window.open(url, '_blank');
      }
    }
  }

  pushClaimToE2(): void {
    this.isSubmitting = true;
    this.validateClaimForm().subscribe(isClaimFormValid => {
      if (isClaimFormValid) {
        this.pushToE2Service.pushClaimToE2(this.claimDto!.claimId).subscribe({
          next: () => {
            this.isSubmitting = false;
            this.pushedToE2.emit();
          },
          error: () => {
            this.isSubmitting = false;
          }
        });
        this.isSubmitting = false;
      } else {
        const modalRef = this.ngbModal.open(ValidationFailedModalComponent, {});
        this.isSubmitting = false;
      }
    });
  }

  validateClaimForm(): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.claimFormValidationService.triggerFormValidation();
      this.claimFormValidationService.validationResult$.pipe(
        take(1)
      ).subscribe(isClaimFormValid => {
        observer.next(isClaimFormValid);
        observer.complete();
      });
    });
  }

}